import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    maxFilesAmount: Number,
  };

  onDragOver(event) {
    // Required to be able to drop items correctly in some browsers
    event.preventDefault();
  }

  onDrop(event) {
    event.preventDefault();

    this.dispatch('before-drop');

    // An image dragged from a web page also carries its URL and HTML as string items.
    const dtItems = event?.dataTransfer?.items;
    const files = Array.from(dtItems || [])
      .filter((dtItem) => dtItem.kind === 'file')
      .map((dtItem) => dtItem.getAsFile());
    this.#dispatchFiles(files);
  }

  dropFromTarget({ target }) {
    const files = Array.from(target?.files || []);
    this.#dispatchFiles(files);
  }

  #dispatchFiles(items) {
    const groups = window.groupByErrors(items, this.maxFilesAmountValue);
    const formattedFiles = this.#prepareFiles(groups.allowed);
    this.dispatch('received', { detail: { extraPayload: formattedFiles } });
    this.dispatch('size-error', { detail: { value: groups.sizeError.length } });
    this.dispatch('type-error', { detail: { value: groups.typeError.length } });
    this.dispatch('amount-error', { detail: { value: groups.amountError.length } });
  }

  #prepareFiles(files) {
    if (files.length === 0) {
      return [];
    }

    return files.map((file) => {
      return { name: 'files[]', value: file };
    });
  }
}
